import { Color } from './color';
/**
 * A filled path.
 */
export const Path = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill' }, options), context);
};
Path.props = {
    defaultMarker: 'hvh',
    defaultEnterAnimation: 'fadeIn',
    defaultUpdateAnimation: 'morphing',
    defaultExitAnimation: 'fadeOut',
};
//# sourceMappingURL=path.js.map